const ICON_LEGEND = ({ color = "#000", strokeWidth = 3, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <path
      d="M3.016 1h3.968M3.016 5h3.968M3.016 9h3.968"
      style={{
        fill: "none",
        paintOrder: "markers fill stroke",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        stroke: color,
      }}
    />
  </svg>
);

export default ICON_LEGEND;
